import {
  Box,
  Button,
  Flex,
  useColorModeValue,
  useMediaQuery,
  Avatar,
  Text,
  Stack,
  Textarea,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { AiOutlineSend } from "react-icons/ai";
import useSmallScreen from "../useSmallScreen";
import { AttendeesCard } from "./AttendeesCard";
import { chats } from "./meetingMessaging/MeetingMessaging";
import MeetingMessagingTextBox from "./meetingMessaging/MeetingMessagingTextBox";

export const MeetingAttendeesList = ({
  list,
  onlyShowParticipants,
  ...props
}) => {
  const containerBgColor = useColorModeValue("#fff", "#020b19");
  let btnStyles = {
    p: "0px 25px",
    h: "35px",
    fontSize: ".6em",
    borderRadius: "18px",
    boxShadow: "lg",
  };

  const [currentTab, setCurrentTab] = useState(0);
  const [smallScreen] = useSmallScreen();
  const textColor = useColorModeValue("#000", "#000");

  return (
    <Box
      bg={containerBgColor}
      height="100%"
      p="20px"
      borderRadius={"10px"}
      w="100%"
      boxSizing="border-box"
      h="85vh"
      overflowY="scroll"
      className="scroll-container"
      position={"relative"}
      {...props}
    >
      {!onlyShowParticipants && (
        <Flex flexDirection={"row"} gap="10px" mb="20px">
          <Button
            {...btnStyles}
            flex={smallScreen ? "1" : "unset"}
            onClick={() => setCurrentTab(0)}
            boxSizing="border-box"
            bg={currentTab === 0 ? "#2D3F7B" : "#FAFBFC"}
            color={currentTab === 0 ? "#fff" : "#7D96B3"}
          >
            Participants{" "}
          </Button>

          <Button
            {...btnStyles}
            flex={smallScreen ? "1" : "unset"}
            onClick={() => setCurrentTab(1)}
            boxSizing="border-box"
            p="0px 40px"
            bg={currentTab === 1 ? "#2D3F7B" : "#FAFBFC"}
            color={currentTab === 1 ? "#fff" : "#7D96B3"}
            boxShadow={"sm"}
          >
            Chat
          </Button>
        </Flex>
      )}

      {currentTab === 0 ? (
        <Flex flexDirection={"column"} gap="0px">
          {list?.map((attendee, key) => {
            return <AttendeesCard key={key} />;
          })}
        </Flex>
      ) : (
        <>
          <Flex
            flexDirection={"column"}
            gap="20px"
            mb="20px"
          >
            {chats?.map((data) => (
              <Flex
                flexDirection={"row"}
                alignItems="flex-start"
                key={data?.id}
                gap="5px"
                mr="5px"
              >
                <Avatar border="2px solid #fff" size="xs" />
                <Text
                  fontSize={".6em"}
                  maxW="250px"
                  whiteSpace="pre-wrap"
                  bg="#E4E4E4"
                  p="7px"
                  borderRadius={"6px"}
                  color={textColor}
                >
                  {data?.text}
                </Text>
              </Flex>
            ))}
          </Flex>
          {/* text box area */}
          <Stack
            direction="row"
            alignItems={"center"}
            borderRadius={"10px"}
            p="10px"
            bg="#D9D9D94F"
            left="0px"
            right="0px"
            position={"absolute"}
            bottom="10px"
            w="90%"
            m="0 auto"
          >
            <Textarea
              rows="1"
              size={"sm"}
              style={{ resize: "none" }}
              fontWeight="600"
              fontSize={[".8em", "unset"]}
              _placeholder={{ color: "#7D96B3", fontWeight: "initial" }}
              placeholder="Type a message here"
              type="text"
              bg={"transparent"}
              overflow=""
              border="none"
            />
            <Stack direction={"row"} alignItems="center" ml="-80px" mt="20px">
              <Flex
                bg="#50BB69"
                color="#fff"
                borderRadius={"5px"}
                w="20px"
                h="20px"
                justifyContent="center"
                alignItems="center"
              >
                <AiOutlineSend fontSize={"1.2em"} cursor="pointer" />
              </Flex>
            </Stack>
          </Stack>
        </>
      )}
    </Box>
  );
};
